export enum MerchantServiceTypeEnum {
    Delivery = 1,
    PickUp = 2,
    Booking = 3
}
